import { defineMessages } from 'react-intl';

export const messages: {
	eyebrow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	eyebrowMcp: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tabCli: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tabMcp: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tabCliAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tabMcpAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewDocs: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewDocsAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	terminalOsDropdownAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyToClipboard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyToClipboardAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	worksWith: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	plusAnyApp: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentRovo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentRovoDev: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentDia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentCursor: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentCodex: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentClaudeCode: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentGeminiCli: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentSalesforceAi: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentMsCopilot: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentGithubCopilot: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentNotionAi: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentAugment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentKiro: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	agentOpencode: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mcpTerminalCopyAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mcpToolsHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eyebrow: {
		id: 'twg-microsite.gettingStarted.eyebrow',
		defaultMessage: '{twg_branding} CLI',
		description: 'Small uppercase eyebrow above the Get-started heading.',
	},
	eyebrowMcp: {
		id: 'twg-microsite.gettingStarted.eyebrow.mcp.non-final',
		defaultMessage: 'Deployment',
		description:
			'Small uppercase eyebrow shown above the Get-started heading when the MCP tab is selected.',
	},
	heading: {
		id: 'twg-microsite.gettingStarted.heading',
		defaultMessage: 'Get started in seconds',
		description: 'Main heading for the Get Started CLI section.',
	},
	tabCli: {
		id: 'twg-microsite.gettingStarted.tab.cli',
		defaultMessage: 'CLI',
		description: 'Label for the CLI tab in the get-started toggle.',
	},
	tabMcp: {
		id: 'twg-microsite.gettingStarted.tab.mcp',
		defaultMessage: 'MCP',
		description: 'Label for the MCP tab in the get-started toggle.',
	},
	tabCliAriaLabel: {
		id: 'twg-microsite.gettingStarted.tab.cli.ariaLabel',
		defaultMessage: 'Show CLI install instructions',
		description: 'Accessible label for the CLI tab button.',
	},
	tabMcpAriaLabel: {
		id: 'twg-microsite.gettingStarted.tab.mcp.ariaLabel',
		defaultMessage: 'Show MCP install instructions',
		description: 'Accessible label for the MCP tab button.',
	},
	viewDocs: {
		id: 'twg-microsite.gettingStarted.viewDocs',
		defaultMessage: 'View docs',
		description: 'Label for the View docs button below the supported-agents row.',
	},
	viewDocsAriaLabel: {
		id: 'twg-microsite.gettingStarted.viewDocs.ariaLabel',
		defaultMessage: 'View {twg_branding} CLI documentation',
		description: 'Accessible label for the View docs button.',
	},
	terminalOsDropdownAriaLabel: {
		id: 'twg-microsite.gettingStarted.terminal.os.dropdown.ariaLabel.non-final',
		defaultMessage: 'Choose operating system',
		description:
			'Accessible label for the dropdown trigger that picks which OS the install commands should target.',
	},
	copyToClipboard: {
		id: 'twg-microsite.gettingStarted.terminal.copyToClipboard.non-final',
		defaultMessage: 'Copy to clipboard',
		description: 'Label for the button that copies the terminal commands to the clipboard.',
	},
	copyToClipboardAriaLabel: {
		id: 'twg-microsite.gettingStarted.terminal.copyToClipboard.ariaLabel.non-final',
		defaultMessage: 'Copy install commands to clipboard',
		description: 'Accessible label for the copy-to-clipboard button in the terminal header.',
	},
	worksWith: {
		id: 'twg-microsite.gettingStarted.worksWith',
		defaultMessage: 'Works with',
		description: 'Heading above the row of supported AI agents/tools.',
	},
	plusAnyApp: {
		id: 'twg-microsite.gettingStarted.plusAnyApp',
		defaultMessage: 'Plus any app with CLI support',
		description: 'Footnote below the row of supported AI agents/tools.',
	},
	agentRovo: {
		id: 'twg-microsite.gettingStarted.agent.rovo',
		defaultMessage: 'Rovo',
		description: 'Label for the Rovo agent pill.',
	},
	agentRovoDev: {
		id: 'twg-microsite.gettingStarted.agent.rovoDev',
		defaultMessage: 'Rovo Dev',
		description: 'Label for the Rovo Dev agent pill.',
	},
	agentDia: {
		id: 'twg-microsite.gettingStarted.agent.dia',
		defaultMessage: 'Dia',
		description: 'Label for the Dia agent pill 123',
	},
	agentCursor: {
		id: 'twg-microsite.gettingStarted.agent.cursor',
		defaultMessage: 'Cursor',
		description: 'Label for the Cursor agent pill.',
	},
	agentCodex: {
		id: 'twg-microsite.gettingStarted.agent.codex',
		defaultMessage: 'Codex',
		description: 'Label for the Codex agent pill.',
	},
	agentClaudeCode: {
		id: 'twg-microsite.gettingStarted.agent.claudeCode',
		defaultMessage: 'Claude Code',
		description: 'Label for the Claude Code agent pill.',
	},
	agentGeminiCli: {
		id: 'twg-microsite.gettingStarted.agent.geminiCli',
		defaultMessage: 'Gemini CLI',
		description: 'Label for the Gemini CLI agent pill.',
	},
	agentSalesforceAi: {
		id: 'twg-microsite.gettingStarted.agent.salesforceAi',
		defaultMessage: 'Salesforce AI',
		description: 'Label for the Salesforce AI agent pill.',
	},
	agentMsCopilot: {
		id: 'twg-microsite.gettingStarted.agent.msCopilot',
		defaultMessage: 'Microsoft Copilot',
		description: 'Label for the Microsoft Copilot agent pill.',
	},
	agentGithubCopilot: {
		id: 'twg-microsite.gettingStarted.agent.githubCopilot',
		defaultMessage: 'Github Copilot',
		description: 'Label for the Github Copilot agent pill.',
	},
	agentNotionAi: {
		id: 'twg-microsite.gettingStarted.agent.notionAi',
		defaultMessage: 'Notion AI',
		description: 'Label for the Notion AI agent pill.',
	},
	agentAugment: {
		id: 'twg-microsite.gettingStarted.agent.augment',
		defaultMessage: 'Augment',
		description: 'Label for the Augment agent pill.',
	},
	agentKiro: {
		id: 'twg-microsite.gettingStarted.agent.kiro',
		defaultMessage: 'Kiro',
		description: 'Label for the Kiro agent pill.',
	},
	agentOpencode: {
		id: 'twg-microsite.gettingStarted.agent.opencode',
		defaultMessage: 'OpenCode',
		description: 'Label for the OpenCode agent pill.',
	},
	mcpTerminalCopyAriaLabel: {
		id: 'twg-microsite.gettingStarted.mcp.terminal.copy.ariaLabel.non-final',
		defaultMessage: 'Copy MCP server URL to clipboard',
		description:
			'Accessible label for the copy-to-clipboard button next to the MCP server URL in the terminal mockup.',
	},
	mcpToolsHeading: {
		id: 'twg-microsite.gettingStarted.mcp.tools.heading.non-final',
		defaultMessage: 'All these tools and more...',
		description: 'Heading shown above the row of MCP tool pills when the MCP tab is selected.',
	},
});
